import {
  Grid,
  TextField,
  Typography,
  Fade,
  Modal,
  Box,
  Backdrop,
  Button,
} from "@material-ui/core";
import useCustomState from "../../hooks/State";
import Call from "../../service/API";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { ERROR_COLOR } from "../../utils/const";

import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import "../../assets/css/calendar.css";
import { utils } from "react-modern-calendar-datepicker";
import moment from "jalali-moment";
import { getJsonDate } from "../../utils/TimeUtils";
import Swal from "sweetalert2";
import BillResponseModal from "../Bill/BillResponseModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper", //   border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const getDate = (days, prevOrNext) => {
  let date;
  if (prevOrNext == "Prev") {
    date = moment().add(-Number(days), "day");
  } else {
    date = moment().add(Number(days), "day");
  }

  date = date.locale("fa").format("YYYY/MM/DD");
  const jsonDate = {
    year: Number(date.split("/")[0]),
    month: Number(date.split("/")[1]),
    day: Number(date.split("/")[2]),
  };

  return jsonDate;
};

const showDate = (date) => {
  return date.year + "/" + date.month + "/" + date.day;
};

const ModalBills = (props) => {
  const handleClose = () => {
    props.open.handleChange(false);
  };
  const errModalStatus = useCustomState(false);
  const successedBills = useCustomState([]);
  const failedBills = useCustomState([]);
  //   dates
  const numBefore = 30;
  const numAfter = 10;
  const monthBefor = moment().add(-numBefore, "day").locale("fa");
  const tenAfter = moment().add(numAfter, "day").locale("fa");
  //..............................
  const startDate = useCustomState(getJsonDate(monthBefor));
  const endDate = useCustomState(utils("fa").getToday());
  const deadLine = useCustomState(getJsonDate(tenAfter));
  const billDetails = useCustomState("");
  const payDetails = useCustomState("");
  const startDateChanged = (newDate) => {
    startDate.handleChange(newDate);
  };
  const endDateChanged = (newDate) => {
    endDate.handleChange(newDate);
  };
  const deadLineChanged = (newDate) => {
    deadLine.handleChange(newDate);
  };
  const startDateRenderer = ({ ref }) => (
    <TextField
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(startDate.value))}
      fullWidth
      variant="standard"
      label="از تاریخ"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );
  const endDateRenderer = ({ ref }) => (
    <TextField
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(endDate.value))}
      fullWidth
      variant="standard"
      label="تا تاریخ"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );
  const deadLineRenderer = ({ ref }) => (
    <TextField
      aria-readonly={true}
      ref={ref}
      value={convertNumbers(showDate(deadLine.value))}
      fullWidth
      variant="standard"
      label="مهلت پرداخت"
      InputLabelProps={{
        style: {
          fontFamily: "Vazir",
        },
      }}
      size="small"
    ></TextField>
  );
  const createBills = () => {
    let utc_start_date = moment(showDate(startDate.value), "jYYYY/jM/jD")
      .locale("utc")
      .format("YYYY-MM-DD");
    let utc_end_date = moment(showDate(endDate.value), "jYYYY/jM/jD")
      .locale("utc")
      .format("YYYY-MM-DD");
    let utc_deadline_date = moment(showDate(deadLine.value), "jYYYY/jM/jD")
      .locale("utc")
      .format("YYYY-MM-DD");
    let cal_method = "from_project"; //['from_project', 'from_meter', 'project_priority', 'meter_priority']
    let data = {
      meter_serial_list: props.selectedList,
      calculate_method: cal_method,
      project_id: props.pid,
      tag_id: props.tid,
      payment_dead_line: utc_deadline_date,
      start_time: utc_start_date,
      end_time: utc_end_date,
      other_information: {
        bill_details: billDetails.value,
        pay_details: payDetails.value,
      },
    };
    Call("POST", "bills/admin/createBill/list", data)
      .then((response) => {
        if (response.data.code === 200) {
          handleClose();
          billsResponseHandler(response.data.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          Swal.fire({
            toast: true,
            showCancelButton: false,
            title: "در صدور قبض خطایی رخ داده است",
            timer: 4000,
            icon: "danger",
            position: "top-start",
            timerProgressBar: true,
          });
        }
      });
  };
  const billsResponseHandler = (response) => {
    const total = response.all_meters_inputed;
    const failed = response.all_bill_not_created;
    const success = response.all_bill_successfully_created;
    if (total === success.count) {
      Swal.fire({
        toast: false,
        showCancelButton: false,
        title: "قبض کنتورهای انتخاب شده با موفقیت صادر شد",
        timer: 3000,
        icon: "success",
        // position: "top-start",
        timerProgressBar: false,
      });
    } else {
      successedBills.handleChange(success.details);
      failedBills.handleChange(failed.details);
      errModalStatus.handleChange(true);
    }
  };
  return (
    <>
      <BillResponseModal
        open={errModalStatus}
        successed={successedBills.value}
        failed={failedBills.value}
      />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={props.open.value}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open.value}>
          <Box sx={style} style={{ borderRadius: "8px" }}>
            <Typography id="transition-modal-title" variant="h5" component="h2">
              صدور قبض
            </Typography>
            <Grid container xs={12} sm={12} md={12} lg={12}>
              <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <DatePicker
                  style={{ margin: "5px 0" }}
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  value={startDate.value}
                  onChange={startDateChanged}
                  renderInput={startDateRenderer}
                  colorPrimary="#0eca2d" // added this
                  calendarClassName="custom-calendar" // and this
                  calendarTodayClassName="custom-today-day" // also this
                  shouldHighlightWeekends
                  locale="fa"
                  maximumDate={getDate(30, "Next")}
                />
                <DatePicker
                  style={{ margin: "5px 0" }}
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  value={endDate.value}
                  onChange={endDateChanged}
                  renderInput={endDateRenderer}
                  colorPrimary="#0eca2d" // added this
                  calendarClassName="custom-calendar" // and this
                  calendarTodayClassName="custom-today-day" // also this
                  shouldHighlightWeekends
                  locale="fa"
                  maximumDate={getDate(30, "Next")}
                />
                <TextField
                  style={{ margin: "10px 0" }}
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  value={billDetails.value}
                  fullWidth
                  variant="standard"
                  label="توضیحات قبض"
                  placeholder="توضیحات قبض وارد کنید"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) => billDetails.handleChange(e.target.value)}
                  size="small"
                ></TextField>
                <TextField
                  style={{ margin: "10px 0" }}
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  value={payDetails.value}
                  fullWidth
                  variant="standard"
                  label="توضیحات پرداخت"
                  placeholder="توضیحات پرداخت وارد کنید"
                  InputLabelProps={{
                    style: {
                      fontFamily: "Vazir",
                    },
                  }}
                  onChange={(e) => payDetails.handleChange(e.target.value)}
                  size="small"
                ></TextField>
                <DatePicker
                  style={{ margin: "5px 0" }}
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  value={deadLine.value}
                  onChange={deadLineChanged}
                  renderInput={deadLineRenderer}
                  colorPrimary="#0eca2d" // added this
                  calendarClassName="custom-calendar" // and this
                  calendarTodayClassName="custom-today-day" // also this
                  shouldHighlightWeekends
                  locale="fa"
                  maximumDate={getDate(30, "Next")}
                />
              </Grid>
              <Grid
                style={{ marginTop: "48px" }}
                item
                xs={12}
                sm={12}
                md={12}
                lg={12}
              >
                <Button
                  onClick={createBills}
                  style={{ color: "#fff" }}
                  variant="contained"
                  color="primary"
                >
                  صدور
                </Button>
                <Button
                  onClick={handleClose}
                  style={{
                    color: "#fff",
                    marginRight: "4px",
                    backgroundColor: ERROR_COLOR,
                  }}
                  variant="contained"
                >
                  انصراف
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
export default ModalBills;
